import { useTranslation } from 'react-i18next';
import { VouchersTabs } from '..';
import { resources } from '../../../../resources/resources';

interface VouchersTabNavProps {
  activeTab: VouchersTabs;
  onTabChange: (tab: VouchersTabs) => void;
}

export const VouchersTabNav = ({
  activeTab,
  onTabChange,
}: VouchersTabNavProps) => {
  const { t: translate } = useTranslation();

  return (
    <ul className="acc-tabs">
      <li
        className={
          activeTab === VouchersTabs.Active ? 'acc-tab-active' : undefined
        }
      >
        <button
          type="button"
          className="cursor-pointer btn-no-style"
          onClick={() => onTabChange(VouchersTabs.Active)}
        >
          {translate(resources.vouchers.active)}
        </button>
      </li>
      <li
        className={
          activeTab === VouchersTabs.Used ? 'acc-tab-active' : undefined
        }
      >
        <button
          type="button"
          className="cursor-pointer btn-no-style"
          onClick={() => onTabChange(VouchersTabs.Used)}
        >
          {translate(resources.vouchers.used)}
        </button>
      </li>
    </ul>
  );
};
